import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

export default function PrivateRoute() {
  const { user, loading } = useAuthContext();

  if (loading) return <LoadingSpinner fullScreen />;
  if (!user)   return <Navigate to="/login" replace />;

  return <Outlet />;
}
